import CartDrawerView from "@/app/shared/ecommerce/cart/cart-drawer-view";
import FloatingCartButton from "@/app/shared/floating-cart-button";
import routes from "@/routers/routes";
import { useCart } from "@/store/quick-cart/cart.context";
import { useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";

import { Drawer } from "rizzui";

export default function CartDrawer() {
    const [openDrawer, setOpenDrawer] = useState(false);
    const location = useLocation();
    const params = useSearchParams();
    const { id } = useParams();

    // list of included pages
    const includedPaths: string[] = [
        routes.eCommerce.shop,
        routes.eCommerce.productDetails(id as string),
    ];

    const isPathIncluded = includedPaths.some(
        (path) => location.pathname === path,
    );

    const {
        totalItems,
        items,
        removeItemFromCart,
        clearItemFromCart,
        total,
        addItemToCart,
    } = useCart();
    return (
        <>
            {isPathIncluded ? (
                <FloatingCartButton
                    onClick={() => setOpenDrawer(true)}
                    className="top-1/2 -translate-y-1/2 bg-primary dark:bg-primary"
                    totalItems={totalItems}
                />
            ) : null}
            <Drawer
                isOpen={openDrawer ?? false}
                onClose={() => setOpenDrawer(false)}
                overlayClassName="dark:bg-opacity-40 dark:backdrop-blur-md"
                containerClassName="dark:bg-gray-100"
                className="z-[9999]"
            >
                <CartDrawerView
                    setOpenDrawer={setOpenDrawer}
                    clearItemFromCart={clearItemFromCart}
                    removeItemFromCart={removeItemFromCart}
                    addItemToCart={addItemToCart}
                    items={items}
                    total={total}
                />
            </Drawer>
        </>
    );
}
